"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BANNER_PRODUCT_LISTING_SKELETON_DIVIDER = exports.BANNER_PRODUCT_LISTING_SKELETON = void 0;
const BANNER_PRODUCT_LISTING_SKELETON = exports.BANNER_PRODUCT_LISTING_SKELETON = 'banner-product-listing-skeleton';
const BANNER_PRODUCT_LISTING_SKELETON_DIVIDER = exports.BANNER_PRODUCT_LISTING_SKELETON_DIVIDER = 'banner-product-listing-skeleton-divider';
